import { faPlus } from '@fortawesome/free-solid-svg-icons';
import type { FC } from 'react';

import Button from '@/components/Button';
import AddNoteDialog from '@/components/Profile/AddNoteDialog';
import Note from '@/components/Profile/Notes/Note';
import Text from '@/components/Text';
import { useExternalCandidate } from '@/hooks/useExternalCandidate';

type Props = {
  id: number;
};
const Notes: FC<Props> = ({ id }) => {
  const { data } = useExternalCandidate(id);
  if (!data) return null;
  return (
    <div className="flex flex-1 flex-col overflow-auto">
      <div className="flex w-full items-center justify-between gap-2 border-b border-neutral-800 pb-2">
        <Text className="font-semibold">Notes</Text>
        <AddNoteDialog id={id}>
          <Button
            variant="primaryLight"
            size="sm"
            className="!py-1 px-2 text-neutral-0"
            prefixIcon={faPlus}
          >
            Add note
          </Button>
        </AddNoteDialog>
      </div>
      <div className="scroll-transparent grid flex-1 grid-cols-[repeat(auto-fill,minmax(14rem,1fr))] gap-4 overflow-auto pt-4">
        {data.notes.map((note) => (
          <Note key={note.id} candidateId={id} note={note} />
        ))}
      </div>
    </div>
  );
};

export default Notes;
